import {
	errorHandler,
	deviceDetect,
	modalsSlice,
	NOTIFICATION_TYPE,
	notifyMessageCreator,
	taskSlice,
	ErrorCode,
	loadersSlice,
	gridSlice,
	regionByIpSelectors,
	regionByIpSlice,
	getRegionByIpSaga,
} from 'Modules'
import { all, call, put, select, takeLatest, takeLeading } from 'typed-redux-saga'

import { RequestParams, ResponseCatalog } from 'Models'
import { get } from 'lodash'
import {
	orderApi,
	OrderModel,
	orderSelectors,
	ordersNS,
	ordersSlice,
	reserveAccountSlice,
	reserveAccountSelectors,
	OrderStepType,
	BlockError,
	productSelectors,
	ProductStatus,
	errorsPosaddress,
	AGREEMENT_STATE,
	unBlockRequestApi,
	OrderStatus,
	prepareOrderToSave,
	createModalContent,
	createIntegratedProductsModalConfig,
	getMobileProduct,
	getSortedIntegratedProducts,
	hasIntegrationProduct,
	hasProductsSlug,
	openExternalLink,
} from 'Pages/orders_design'
import { authSelector } from 'Pages/auth'
import { routerActions } from 'connected-react-router'
import { FrontUrls } from 'Constants/FrontUrls'
import { FormNames } from 'Constants/FormNames'
import { MODAL_NAME } from 'Constants/ModalName'
import { ProductSlugs } from 'Constants/ProductSlugs'
import { OutLinks } from 'Constants/OutLinks'
import { NewOrderModal } from 'Pages/orders_design/components/desktop_orders/modals/NewOrderModal'
import { IframeModalComponent } from 'Pages/orders_design/components/desktop_orders/modals/IframeModal'
import { FieldNames } from 'Constants/FieldNames'
import { blobToBase64 } from 'base64-blob'
import { Deserialize } from 'cerialize'
import { leadsSlice, PARENT_TYPE_LEAD, STATUSES_FOR_REQUEST_LEAD } from 'Pages/lead'
import { takeEveryUnique } from 'Helpers'

function* getOrders(action: ordersNS.getAll) {
	const isMobile = yield* select(deviceDetect.getIsMobile)
	try {
		const { params, clear, callback } = action.payload
		if (isMobile) {
			yield* put(gridSlice.actions.setLoading(true))
		} else {
			yield* put(loadersSlice.actions.showGlobalLoader())
		}
		const { page, per_page, query, ...fields } = params
		const requestParams = new RequestParams(clear ? 1 : page, per_page, query, fields)
		if (clear) {
			yield* put(ordersSlice.actions.clearAll())
		}
		const res = yield* call(orderApi.getAll, requestParams.withoutTotalEntries)
		const orders = new ResponseCatalog<OrderModel>(res)
		if (!clear) {
			const oldOrders = yield* select(orderSelectors.getAll)
			orders.entries = [...oldOrders.entries, ...res.entries]
		}
		const order_ids = res?.entries.map((item) => item.id)
		const paramsForTasks = new RequestParams(1, per_page)
		const data = {
			params: paramsForTasks,
			clear: page === 1,
			order_ids,
		}
		yield* put(ordersSlice.actions.setAll(orders))
		yield* put(ordersSlice.actions.setParams(requestParams))
		const auth = yield* select(authSelector.getAuth)
		const showTask = auth.permissions.order_task_available
		if (showTask) {
			yield* put(taskSlice.actions.getTasks(data))
		}
		if (isMobile) {
			yield* put(gridSlice.actions.setLoading(false))
		} else {
			yield* put(loadersSlice.actions.hideGlobalLoader())
		}
		callback?.()
		if (orders.current_page === 1 && !res.total_entries) {
			yield* call(getTotalEntries, requestParams)
		}
	} catch (error) {
		if (isMobile) {
			yield* put(gridSlice.actions.setLoading(false))
		} else {
			yield* put(loadersSlice.actions.hideGlobalLoader())
		}
		yield* call(errorHandler, error)
	}
}

function* getTotalEntries(params: RequestParams) {
	try {
		yield* put(ordersSlice.actions.setTotalEntriesLoader(true))
		const res = yield* call(orderApi.getAll, params.onlyTotalEntries)
		const items = yield* select(orderSelectors.getAll)
		yield* put(ordersSlice.actions.setAll({ ...items, total_entries: res?.total_entries }))
		yield* put(ordersSlice.actions.setTotal(res?.total_entries))
		yield* put(ordersSlice.actions.setTotalEntriesLoader(false))
	} catch (error) {
		yield* call(errorHandler, error)
	}
}

export function* getTotalSaga(action: ordersNS.getTotal) {
	try {
		const res = yield* call(orderApi.getTotal, action.payload.params)
		// @ts-ignore TODO: NC-5191 - res is actualy { count: number } but setTotal expects a number
		// TODO: (this saga is not called at all, maybe we should remove it)
		yield* put(ordersSlice.actions.setTotal(res))
	} catch (error) {
		yield* call(errorHandler, error)
	}
}

function* cancelDzoStatus(action: ordersNS.cancelDzoStatus) {
	try {
		yield* call(orderApi.dzoStatusApi, action.payload)
		yield* call(notifyMessageCreator, 'orders.statuses_cancel.success')
	} catch (error) {
		yield* call(errorHandler, error)
	}
}

function* paoSberbankStatus(action: ordersNS.paoSberbankStatus) {
	try {
		yield* call(orderApi.paoSberbankStatusApi, action.payload)
		yield* call(notifyMessageCreator, 'orders.statuses_cancel.success')
	} catch (error) {
		yield* call(errorHandler, error)
	}
}

function* crmStatusesStatus(action: ordersNS.crmStatus) {
	try {
		yield* call(orderApi.crmStatusesStatusApi, action.payload)
		yield* call(notifyMessageCreator, 'orders.statuses_cancel.success')
	} catch (error) {
		yield* call(errorHandler, error)
	}
}

function* sendOrdersReport(action: ordersNS.sendOrdersReport) {
	try {
		yield* put(loadersSlice.actions.showGlobalLoader())
		yield* call(orderApi.sendOrdersReport, action.payload.type, action.payload.params)
		yield* put(loadersSlice.actions.hideGlobalLoader())
		yield* call(notifyMessageCreator, 'common.report_send.success')
	} catch (error) {
		yield* put(loadersSlice.actions.hideGlobalLoader())
		yield* call(errorHandler, error)
	}
}

function* sendPaymentStatuses(action: ordersNS.sendPaymentStatuses) {
	try {
		yield* call(notifyMessageCreator, 'common.payment_statuses_send.in_progress')
		yield* call(orderApi.sendPaymentStatuses, action.payload)
		yield* call(notifyMessageCreator, 'common.payment_statuses_send.success')
	} catch (error) {
		yield* call(errorHandler, error)
	}
}

function* sendCorusStauses(action: ordersNS.sendCorusStatuses) {
	try {
		yield* call(notifyMessageCreator, 'orders.corus_statuses_send.in_progress')
		yield* call(orderApi.sendCorusStatuses, action.payload)
		yield* call(notifyMessageCreator, 'orders.corus_statuses_send.success')
	} catch (error) {
		yield* call(errorHandler, error)
	}
}

function* sendCRMStauses(action: ordersNS.sendCRMStatuses) {
	try {
		yield* call(notifyMessageCreator, 'orders.crm_statuses_send.in_progress')
		yield* call(orderApi.sendCRMStatuses, action.payload)
		yield* call(notifyMessageCreator, 'orders.crm_statuses_send.success')
	} catch (error) {
		yield* call(errorHandler, error)
	}
}

function* buildOrder(action: ordersNS.buildOrder) {
	const isMobile = yield* select(deviceDetect.getIsMobile)
	try {
		yield* put(loadersSlice.actions.showGlobalLoader())
		const res = yield* call(orderApi.buildOrder, action.payload)
		if (action.payload.accept_blocked) {
			yield* put(ordersSlice.actions.setAcceptBlocked())
		}
		const order = Object.assign(new OrderModel(), res)
		yield* put(ordersSlice.actions.setOrder(order))
		if (isMobile) {
			yield* put(routerActions.push(FrontUrls.orders_redesign_mobile.form))
		} else {
			yield* put(routerActions.push(FrontUrls.orders_redesign.edit.replace(':id', '0')))
		}
		const isWithReserve = yield* select(reserveAccountSelectors.getIsPossible)
		yield* put(
			ordersSlice.actions.setStep(
				isWithReserve ? OrderStepType.NEW_ORDER_WITH_RESERVE : OrderStepType.NEW_ORDER
			)
		)
		yield* put(loadersSlice.actions.hideGlobalLoader())
	} catch (error) {
		yield* put(loadersSlice.actions.hideGlobalLoader())
		const errors = get(error, 'data.errors[0]', {})
		if (Object.keys(errors)[0] in BlockError) {
			const { Component } = createModalContent(errors, action.payload, isMobile)
			yield* put(
				modalsSlice.actions.showModal({
					Component,
					key: MODAL_NAME.ORDERS_BLOCK,
					width: isMobile ? '320px' : '480px',
					closable: false,
				})
			)
		}
		yield* call(errorHandler, error, FormNames.ORDERS.BUILD_ORDER)
	}
}

function* showIntegrationProductModal(slug: ProductSlugs, inn: string, orderId: number) {
	const config = createIntegratedProductsModalConfig(slug, inn)
	if (config) {
		yield* put(
			modalsSlice.actions.showModal({
				Component: IframeModalComponent,
				width: '70vw',
				key: config.modalName,
				title: config.titleCode,
				componentProps: { url: config.url, orderId },
				hideOnlyByUser: true,
			})
		)
	}
}

function* convertToBase64(file: File) {
	const base64 = yield* call(blobToBase64, file)
	return { file: base64, file_file_name: file?.name }
}

function* getConvertedFileList(fileList: File[]) {
	const res = []
	for (let i = 0; i < fileList.length; i += 1) {
		if (fileList[i]) res.push(yield* call(convertToBase64, fileList[i]))
	}
	return res
}
function* prepareFiles(order: OrderModel) {
	if (order[FieldNames.RBIDOS]) {
		const file = new File(['rbidos'], 'rbidos.txt', { type: 'plain/text' })
		const fileConverted = yield* call(convertToBase64, file)
		const unblock_request_attributes = {
			rbidos: true,
			files_attributes: [
				{
					file: fileConverted?.file,
					file_file_name: 'rbidos.txt',
				},
			],
		}
		return Object.assign(new OrderModel(), order, { unblock_request_attributes })
	}
	if (order[FieldNames.FILE]) {
		const { file, ...reformatOrder } = order // eslint-disable-line
		const unblock_request_attributes = {
			rbidos: false,
			files_attributes: yield* getConvertedFileList(Array.isArray(file) ? file : [file]),
		}

		return Object.assign(new OrderModel(), reformatOrder, { unblock_request_attributes })
	}
	return order
}

function* createOrder(action: ordersNS.createOrder) {
	const isMobile = yield* select(deviceDetect.getIsMobile)
	try {
		yield* put(loadersSlice.actions.showGlobalLoader())
		const reformatOrder = prepareOrderToSave(action.payload.order)
		const newOrder = yield* call(prepareFiles, reformatOrder)
		yield* call(getRegionByIpSaga, regionByIpSlice.actions.getRegion())
		const region = yield* select(regionByIpSelectors.getRegion)

		const res = yield* call(
			orderApi.createOrder,
			Object.assign(new OrderModel(), newOrder, { area_name: region?.name })
		)
		const allProducts = yield* select(productSelectors.getItems)
		const order = Object.assign(new OrderModel(), res)
		const isReserveAccountActive = yield* select(reserveAccountSelectors.getIsActive)
		const isIntegrationProduct = hasIntegrationProduct(order.products)

		if (isIntegrationProduct) {
			if (hasProductsSlug([ProductSlugs.BANK_GUARANTEE as string], order.products)) {
				openExternalLink(OutLinks.bank_guarantee)
			}
			const integratedProducts = getSortedIntegratedProducts(order.products)
			integratedProducts.forEach((product) => {
				const currentProduct = allProducts?.entries.find((item) => item.id === product.id)
				product.priority = currentProduct.priority
			})
			integratedProducts.sort((prev, next) => Number(next?.priority) - Number(prev?.priority))
			const { inn } = action.payload.order
			yield* all(
				integratedProducts.map((product) =>
					// @ts-ignore TODO: NC-5191 - product.slug is string but showIntegrationProductModal expects object
					call(showIntegrationProductModal, product.slug, inn, order.id)
				)
			)
		} else if (
			isReserveAccountActive &&
			order.products.every(({ status }) => status.slug === ProductStatus.DRAFT)
		) {
			yield* call(notifyMessageCreator, 'orders.create.draft', { data: [order.id.toString()] })
		}
		if (isMobile) {
			yield* put(routerActions.push(FrontUrls.orders_redesign_mobile.created))
		} else if (isReserveAccountActive) {
			yield* put(ordersSlice.actions.setStep(OrderStepType.RESERVE_ACCOUNT))
			yield* put(ordersSlice.actions.setConsentShow(false))
		} else {
			yield* put(routerActions.push(FrontUrls.orders_redesign.index))
			if (!isIntegrationProduct) {
				yield* put(
					modalsSlice.actions.showModal({
						Component: NewOrderModal,
						key: MODAL_NAME.ORDER_CREATE,
						componentProps: { orderId: order?.id, isDraft: false },
						width: '480px',
					})
				)
			}
		}
		yield* put(ordersSlice.actions.setOrder(order))
		yield* put(ordersSlice.actions.clearAcceptBlocked())
		yield* put(loadersSlice.actions.hideGlobalLoader())
	} catch (error) {
		yield* put(loadersSlice.actions.hideGlobalLoader())
		const { errorCallback } = action.payload
		if (isMobile) {
			yield* call(errorHandler, error, FormNames.ORDERS.MOBILE.ORDER_FORM)
		} else if (
			error.data?.errors
				?.map((i) => Object.keys(i))
				.flat()
				.some((item): boolean => errorsPosaddress.includes(item))
		) {
			errorCallback?.(error.data?.errors)
			yield* call(notifyMessageCreator, 'orders.address_terminal_error.error', {
				options: { type: NOTIFICATION_TYPE.ERROR },
			})
		} else {
			yield* call(errorHandler, error, FormNames.ORDERS.EDIT_ORDER)
		}
	}
}

function* getBlockExpiresSoon(action: ordersNS.getBlockExpiresSoon) {
	try {
		const res = yield* call(orderApi.getBlockExpiresSoon)
		yield* put(ordersSlice.actions.setBlockExpiresSoon(res?.count))
	} catch (error) {
		yield* call(errorHandler, error)
	}
}

function* getTotalIncompleted(action: ordersNS.getTotalIncompleted) {
	try {
		const res = yield* call(orderApi.getTotalUncompletedOnline)
		yield* put(ordersSlice.actions.setTotalIncompleted(res?.count))
	} catch (error) {
		yield* call(errorHandler, error)
	}
}

function* getTotalUnblockChecking(action: ordersNS.getTotalUnblock) {
	try {
		const res = yield* call(orderApi.getTotalUnblockChecking)
		yield* put(ordersSlice.actions.setTotalUnblock(res?.count))
	} catch (error) {
		yield* call(errorHandler, error)
	}
}

function* deleteOrder(action: ordersNS.deleteOrder) {
	try {
		yield* put(loadersSlice.actions.showGlobalLoader())
		yield* call(orderApi.deleteOrder, action.payload)
		const orders = yield* select(orderSelectors.getAll)
		yield* put(
			ordersSlice.actions.setAll({
				...orders,
				entries: orders.entries?.map((order) =>
					order.id === action.payload ? ({ ...order, is_deleted: true } as typeof order) : order
				),
			})
		)
		const currentOrder = yield* select(orderSelectors.getOrder)
		if (currentOrder.id === action.payload) {
			yield* put(
				ordersSlice.actions.setOrder({ ...currentOrder, is_deleted: true } as typeof currentOrder)
			)
		}
		yield* call(notifyMessageCreator, 'common.delete_request.success')
		yield* put(loadersSlice.actions.hideGlobalLoader())
	} catch (error) {
		yield* put(loadersSlice.actions.hideGlobalLoader())
		yield* call(errorHandler, error)
	}
}

function* getContactDetailsOrder(action: ordersNS.getContactDetailsCurrentOrder) {
	try {
		yield* put(loadersSlice.actions.showGlobalLoader())
		const res = yield* call(orderApi.getContactDetailsOrder, action.payload.id)
		yield* put(
			ordersSlice.actions.setContactDetailsCurrentOrder({
				id: action.payload.id,
				contactDetails: res,
			})
		)
		yield* put(loadersSlice.actions.hideGlobalLoader())
	} catch (error) {
		yield* put(loadersSlice.actions.hideGlobalLoader())
		yield* call(errorHandler, error)
	}
}

function* resendSmsOrder(action: ordersNS.resendSms) {
	try {
		const { id, productSlug } = action.payload
		yield* put(loadersSlice.actions.showGlobalLoader())
		yield* call(orderApi.resendSms, id, productSlug)
		yield* call(notifyMessageCreator, 'common.sms_send.success')
		yield* put(loadersSlice.actions.hideGlobalLoader())
	} catch (error) {
		yield* put(loadersSlice.actions.hideGlobalLoader())
		yield* call(errorHandler, error)
	}
}

function* resendEmailOrder(action: ordersNS.resendEmail) {
	try {
		const { id, productSlug } = action.payload
		yield* put(loadersSlice.actions.showGlobalLoader())
		yield* call(orderApi.resendEmail, id, productSlug)
		yield* call(notifyMessageCreator, 'common.mail_send.success')
		yield* put(loadersSlice.actions.hideGlobalLoader())
	} catch (error) {
		yield* put(loadersSlice.actions.hideGlobalLoader())
		yield* call(errorHandler, error)
	}
}

function* getTotalPartnerRequests(action: ordersNS.getTotalPartnerRequests) {
	try {
		const res = yield* call(orderApi.getTotalPartnerRequests)
		yield* put(ordersSlice.actions.setTotalPartnerRequest(res?.count))
	} catch (error) {
		yield* call(errorHandler, error)
	}
}
function* sendCommentOrder(action: ordersNS.sendComment) {
	try {
		yield* put(loadersSlice.actions.showGlobalLoader())
		const { id, text, callback } = action.payload
		const res = yield* call(orderApi.sendComment, id, text)
		yield* put(ordersSlice.actions.addComment(res))
		yield* put(loadersSlice.actions.hideGlobalLoader())
		callback?.()
	} catch (error) {
		yield* put(loadersSlice.actions.hideGlobalLoader())
		yield* call(errorHandler, error)
	}
}

function* sendClickThrough(action: ordersNS.sendClickThrough) {
	try {
		yield* call(orderApi.sendClickThrough)
	} catch (error) {
		yield* call(errorHandler, error)
	}
}

function* getOtkritieBankCities(action: ordersNS.getOtkritieBankCities) {
	try {
		yield* put(loadersSlice.actions.showGlobalLoader())
		const res = yield* call(orderApi.getOtkritieBankCities)
		yield* put(ordersSlice.actions.setOtkritieBankCities(res.cities))
		yield* put(loadersSlice.actions.hideGlobalLoader())
	} catch (error) {
		yield* put(loadersSlice.actions.hideGlobalLoader())
		yield* call(errorHandler, error)
	}
}

function* getTotalTasks(action: ordersNS.getTotalTasks) {
	try {
		const res = yield* call(orderApi.getTotalTasks)
		yield* put(ordersSlice.actions.setTotalTasks(res?.count))
	} catch (error) {
		yield* call(errorHandler, error)
	}
}

function* getIntegrationOrderSaga(action: ordersNS.getIntegrationOrder) {
	try {
		yield* put(loadersSlice.actions.showGlobalLoader())
		const { id, optionsModal } = action.payload
		const res = yield* call(orderApi.getIntegrationOrder, id)
		const url = getMobileProduct(res.products)?.sber_telecom_auth_url
		if (url) {
			yield* put(modalsSlice.actions.showModal({ ...optionsModal, componentProps: { url } }))
		}
		yield* put(loadersSlice.actions.hideGlobalLoader())
	} catch (error) {
		yield* put(loadersSlice.actions.hideGlobalLoader())
		yield* call(errorHandler, error)
	}
}

function* getOrder(action: ordersNS.getOrder) {
	try {
		yield* put(loadersSlice.actions.showGlobalLoader())
		const { id, updateList } = action.payload
		const res = yield* call(orderApi.getOrder, id)
		const newOrder: OrderModel = Deserialize(res, OrderModel)
		yield* put(ordersSlice.actions.setOrder(newOrder))
		if (!res['readed?'] || updateList) {
			const orders = yield* select(orderSelectors.getAll)
			const entries = orders.entries.map((order) =>
				order.id === res.id
					? ({
							...order,
							'readed?': true,
							status_reserve_account: res.status_reserve_account,
					  } as typeof order)
					: order
			)
			yield* put(ordersSlice.actions.setAll({ ...orders, entries }))
		}
		yield* put(loadersSlice.actions.hideGlobalLoader())
	} catch (error) {
		yield* put(loadersSlice.actions.hideGlobalLoader())
		yield* call(errorHandler, error)
	}
}

function* getOrderAfterRedirect(action: ordersNS.getOrderAfterRedirect) {
	const isMobile = yield* select(deviceDetect.getIsMobile)
	try {
		yield* put(loadersSlice.actions.showGlobalLoader())
		const res = yield* call(orderApi.getOrder, action.payload)
		const newOrder: OrderModel = Deserialize(res, OrderModel)
		yield* put(ordersSlice.actions.setOrder(newOrder))
		yield* put(ordersSlice.actions.setClientINN(newOrder.inn))
		const params = new RequestParams(1, 30, null, {
			parent_type: [PARENT_TYPE_LEAD.ORDER],
			agreement_state: AGREEMENT_STATE.ACTUAL,
			inn: newOrder.inn,
			state: STATUSES_FOR_REQUEST_LEAD[AGREEMENT_STATE.ACTUAL],
		})
		yield* put(
			leadsSlice.actions.getAll({
				params,
				clear: false,
			})
		)

		const possibilityToAddReserveAccount = yield* select(
			orderSelectors.getPossibilityToAddReserveAccount
		)
		const isDraftOrder = yield* select(orderSelectors.isDraftOrder)
		if ((isDraftOrder || possibilityToAddReserveAccount) && !newOrder.reserve_account) {
			yield* put(
				reserveAccountSlice.actions.setReserveAccountOptions({
					newOptions: {
						available: true,
						selected: true,
						locked: false,
					},
				})
			)
			yield* put(ordersSlice.actions.setStep(OrderStepType.RESERVE_ACCOUNT))
		} else {
			yield* put(routerActions.push(FrontUrls.orders_redesign.create))
		}
	} catch (error) {
		yield* put(loadersSlice.actions.hideGlobalLoader())
		if (error.status === ErrorCode.e404) {
			if (isMobile) {
				yield* put(routerActions.push(FrontUrls.orders_redesign_mobile.check_inn))
			} else {
				yield* put(routerActions.push(FrontUrls.orders_redesign.create))
			}
		} else yield* call(errorHandler, error)
	}
}

// function* prepareFilesToSendBack(filesToReplace: File[]) {
// 	const { unblock_request } = yield* select(orderSelectors.getOrder)
// 	const res = []
//
// 	for (let i = 0; i < filesToReplace.length; i += 1) {
// 		if (filesToReplace[i]) {
// 			const convertedFile = yield* call(convertToBase64, filesToReplace[i])
// 			res.push({ ...convertedFile, id: unblock_request.files?.[i]?.id })
// 		}
// 	}
//
// 	return res
// }
function* sendFileBackToChecking(action: ordersNS.sendFileForBackToChecking) {
	try {
		yield* call(notifyMessageCreator, 'common.files_send.start')
		const { unBlockRequestId, files_attributes } = action.payload
		// const files_attributes = yield* call(prepareFilesToSendBack, file)
		const orderWithNewStatus = yield* call(unBlockRequestApi.backToChecking, unBlockRequestId, {
			files_attributes,
		})
		yield* call(notifyMessageCreator, 'common.sending.success')
		const currentRequestParams = yield* select(orderSelectors.getParams)
		if (currentRequestParams.get(FieldNames.STATUS_NAME) === OrderStatus.UNBLOCK_CLARIFICATION) {
			yield* put(ordersSlice.actions.getAll({ params: currentRequestParams, clear: true }))
		} else {
			const orders = yield* select(orderSelectors.getAll)
			yield* put(
				ordersSlice.actions.setAll({
					...orders,
					entries: orders.entries?.map((order) =>
						order.id === orderWithNewStatus.id
							? ({
									...order,
									status_code: orderWithNewStatus.status_code,
									products: orderWithNewStatus.products,
									unblock_request: orderWithNewStatus.unblock_request,
							  } as OrderModel)
							: order
					),
				})
			)
			const currentOrder = yield* select(orderSelectors.getOrder)
			if (currentOrder.id === orderWithNewStatus.id) {
				yield* put(ordersSlice.actions.setOrder(orderWithNewStatus))
			}
		}
		yield* put(ordersSlice.actions.getTotalUnblock())
	} catch (error) {
		yield* call(errorHandler, error)
	}
}

export function* recognizePassport(action: ordersNS.recognizePassport) {
	try {
		yield* put(loadersSlice.actions.showGlobalLoader())
		yield* put(ordersSlice.actions.clearRecognizedData())
		yield* call(orderApi.recognizePassport, action.payload)
		yield* put(ordersSlice.actions.setRecognizeLoading(true))
		yield* put(loadersSlice.actions.hideGlobalLoader())
	} catch (error) {
		yield* put(loadersSlice.actions.hideGlobalLoader())
		yield* call(errorHandler, error)
	}
}

function* getTotalRejectedReservation(action: ordersNS.getTotalRejectedReservation) {
	try {
		const res = yield* call(orderApi.getTotalRejectedReservation)
		yield* put(ordersSlice.actions.setTotalRejectedReservation(res?.count))
	} catch (error) {
		yield* call(errorHandler, error)
	}
}

export function* ordersSaga() {
	yield* takeLeading(ordersSlice.actions.getAll.type, getOrders)
	yield* takeLatest(ordersSlice.actions.sendOrdersReport.type, sendOrdersReport)
	yield* takeLatest(ordersSlice.actions.sendPaymentStatuses.type, sendPaymentStatuses)
	yield* takeLatest(ordersSlice.actions.sendCorusStatuses.type, sendCorusStauses)
	yield* takeLatest(ordersSlice.actions.sendCRMStatuses.type, sendCRMStauses)
	yield* takeLatest(ordersSlice.actions.getOrder.type, getOrder)
	yield* takeLatest(ordersSlice.actions.getOrderAfterRedirect.type, getOrderAfterRedirect)
	yield* takeLatest(ordersSlice.actions.buildOrder.type, buildOrder)
	yield* takeLatest(ordersSlice.actions.createOrder.type, createOrder)
	yield* takeLatest(ordersSlice.actions.getTotal.type, getTotalSaga)
	yield* takeLatest(ordersSlice.actions.getTotalIncompleted.type, getTotalIncompleted)
	yield* takeLatest(ordersSlice.actions.getTotalUnblock.type, getTotalUnblockChecking)
	yield* takeLatest(ordersSlice.actions.getTotalPartnerRequests.type, getTotalPartnerRequests)
	yield* takeLatest(ordersSlice.actions.sendComment.type, sendCommentOrder)
	yield* takeLatest(ordersSlice.actions.deleteOrder.type, deleteOrder)
	yield* takeLatest(ordersSlice.actions.getContactDetailsCurrentOrder.type, getContactDetailsOrder)
	yield* takeLatest(ordersSlice.actions.resendSms.type, resendSmsOrder)
	yield* takeLatest(ordersSlice.actions.resendEmail.type, resendEmailOrder)
	yield* takeLatest(ordersSlice.actions.getIntegrationOrder.type, getIntegrationOrderSaga)
	yield* takeLatest(ordersSlice.actions.sendClickThrough.type, sendClickThrough)
	yield* takeLatest(ordersSlice.actions.getOtkritieBankCities.type, getOtkritieBankCities)
	yield* takeLatest(ordersSlice.actions.getTotalTasks.type, getTotalTasks)
	yield* takeLatest(ordersSlice.actions.cancelDzoStatus.type, cancelDzoStatus)
	yield* takeLatest(ordersSlice.actions.paoSberbankStatus.type, paoSberbankStatus)
	yield* takeLatest(ordersSlice.actions.crmStatus.type, crmStatusesStatus)
	yield* takeLatest(ordersSlice.actions.getBlockExpiresSoon.type, getBlockExpiresSoon)
	yield* takeEveryUnique(ordersSlice.actions.sendFileForBackToChecking.type, sendFileBackToChecking)
	yield* takeLatest(ordersSlice.actions.recognizePassport.type, recognizePassport)
	yield* takeLatest(
		ordersSlice.actions.getTotalRejectedReservation.type,
		getTotalRejectedReservation
	)
}
